import LegalLayout from "@/components/site/LegalLayout";

export default function Privacy() {
  return (
    <LegalLayout title="Privacy Policy" updated="December 2025">
      <section data-testid="privacy-intro">
        <p>
          At Mahaview.in ("we", "us", "our"), we respect your privacy and are committed to protecting
          the personal information you share with us. This Privacy Policy explains what we collect,
          how we use it, and the choices available to you.
        </p>
      </section>

      <section>
        <h2>1. Information We Collect</h2>
        <ul>
          <li><strong>Contact details</strong> you submit via our inquiry form: name, email, phone, selected service, and project brief.</li>
          <li><strong>Communications</strong> when you reach out via WhatsApp, phone, or email.</li>
          <li><strong>Usage data</strong> such as pages visited, device type, and approximate location collected via standard analytics.</li>
          <li><strong>Cookies</strong> used for session management and basic site analytics.</li>
        </ul>
      </section>

      <section>
        <h2>2. How We Use Your Information</h2>
        <ul>
          <li>To respond to your inquiries and deliver requested services.</li>
          <li>To share proposals, quotes, and project updates.</li>
          <li>To improve our website, services, and user experience.</li>
          <li>To send occasional updates about our work (you may opt out anytime).</li>
          <li>To comply with applicable legal obligations.</li>
        </ul>
      </section>

      <section>
        <h2>3. Sharing of Information</h2>
        <p>
          We do not sell your personal information. We may share it with trusted service providers
          (hosting, email, analytics) strictly to operate this website and our services, or when
          required by law.
        </p>
      </section>

      <section>
        <h2>4. Data Retention</h2>
        <p>
          We retain inquiry data only as long as needed to serve you and meet legal requirements.
          You can request deletion of your data at any time.
        </p>
      </section>

      <section>
        <h2>5. Your Rights</h2>
        <ul>
          <li>Request access to the personal data we hold about you.</li>
          <li>Request correction or deletion of your data.</li>
          <li>Withdraw consent for marketing communications.</li>
          <li>Lodge a complaint with the appropriate data-protection authority.</li>
        </ul>
      </section>

      <section>
        <h2>6. Security</h2>
        <p>
          We implement reasonable technical and organisational measures to protect your data.
          No method of transmission over the internet is 100% secure; please share information at
          your own discretion.
        </p>
      </section>

      <section>
        <h2>7. Third-Party Links</h2>
        <p>
          Our website may contain links to third-party platforms (e.g., WhatsApp, social media).
          We are not responsible for the privacy practices of those platforms.
        </p>
      </section>

      <section>
        <h2>8. Updates to This Policy</h2>
        <p>
          We may update this Privacy Policy occasionally. The "Last updated" date at the top reflects
          the latest revision.
        </p>
      </section>

      <section>
        <h2>9. Contact Us</h2>
        <p>
          For any privacy-related questions or requests, contact us at{" "}
          <a href="mailto:mahaview1@gmail.com">mahaview1@gmail.com</a> or call +91 80972 08707.
        </p>
      </section>
    </LegalLayout>
  );
}
